import { createContext, useContext, useEffect, useState } from 'react'
import { useAuth } from './AuthContext'
import { toast } from 'react-toastify'
import api from '../services/api'
import chatbotApi from '../services/chatbotApi'

const CartContext = createContext()

export const CartProvider = (props) => {
  const [cart, setCart] = useState(null)
  const [chatbotCart, setChatbotCart] = useState(null)
  const [chatbotCartObj, setChatbotCartObj] = useState(null)
  const [chatbotCartComments, setChatbotCartComments] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem('chatbotCartComments')) || {}
    } catch {
      return {}
    }
  })
  const [loadingBackground, setLoadingBackground] = useState(false)
  const [productAdded, setProductAdded] = useState(false)
  const { user, chatbotUser } = useAuth()
  const cartInfo = chatbotUser ? JSON.parse(sessionStorage.getItem('chatbotCart')) : JSON.parse(localStorage.getItem('@bendito:cart'))
  const chatbotCustomer = JSON.parse(sessionStorage.getItem('customerChatbot'))
  let previousCartItems = !!cartInfo ? cartInfo.items.length : 0
  let currentCartItems = !!cartInfo ? cartInfo.items.length : 0

  const CustomFinancialToastWithLink = () => (
    <span>Você possui contas em atraso.<br /><a href='/financial' style={{ textDecoration: 'underline', color: 'white', fontWeight: 'bold' }}>Clique aqui</a> para visualizar ou entre em contato com o financeiro.</span>
  )

  const startSaveCart = async (cart, isChatbotCatalog) => {
    const currentStorage = isChatbotCatalog ? sessionStorage : localStorage
    const currentApi = isChatbotCatalog ? chatbotApi : api
    if (!!cart) {
      const cartId = JSON.parse(currentStorage.getItem('@cartId'))
      const cartItemsFormatted = cart.items.map(item => {
        return {
          ProductId: item.productId,
          ProductSkuDataId: !!item.productSkuDataId ? item.productSkuDataId : 0,
          Quantity: item.quantity,
          Value: item.value,
          Tax: item.tax,
          Freight: item.freight,
          Discount: item.politicsDiscount + item.politicsUnitDiscount,
          Addition: item.politicsAddition + item.politicsUnitAddition,
          TotalValue: item.totalValue,
          Comments: item.comments,
          TaxIpi: item.taxIpi,
          TaxSt: item.taxSt,
        }
      })
   
      const data = {
        Status: cart.status,
        ClientId: cart.clientId,
        Value: cart.value,
        Tax: cart.tax,
        Freight: cart.freight,
        Discount: cart.discount,
        PoliticsDiscount: cart.politicsDiscount,
        TotalValue: cart.totalValue,
        Advance: !!cart.advance ? cart.advance : 0,
        Addition: cart.politicsAddition,
        Notes: cart.notes,
        Items: cartItemsFormatted ? cartItemsFormatted : [],
        PaymentMethodId: cart.paymentMethodId,
        DeadlineId: cart.deadlineId,
        CarrierId: cart.carrierId,
        DeliveryForecast: cart.deliveryForecast,
        TaxIpi: cart.taxIpi,
        TaxSt: cart.taxSt,
      }

      if (!!cartId) {
        data.Id = cartId
      } else {
        delete data.id
      }
  
      if (!cartId && cart && ((cart.items.length === 1 && previousCartItems === 0) || isChatbotCatalog) ) {
        try {
          const response = await currentApi.post('/api/v2/Cart', data)
          const responseData = response.data.response.data
          currentStorage.setItem('@cartId', JSON.stringify(responseData.id))
        } catch (error) {
          console.log('error', error);
        }
      } else {
        if (!!cartId) {
          try {
            const response = await currentApi.post(`/api/v2/Cart`, data)
          } catch (error) {
            console.log('error', error);
          }
        }
      }
      previousCartItems = 0
      currentCartItems = 0
    }
  }

  const addProduct = async (productId, qty = 1, gradeId) => {
    previousCartItems = !!cart ? cart.items.length : 0
    if (user.paymentMethod[0] == null) {
      toast.error('Nenhuma forma de pagamento cadastrada pelo vendedor, por favor contate a loja!', {
        position: 'top-right',
      })
    }

    const data = {
      AddProductGradeId: gradeId ? +gradeId : null,
      AddProductId: productId,
      AddQuantity: qty,
      ClientId: user.clientId,
      DeadlineId: (() => {
        var activeDeadline = user.deadline?.find(deadline => deadline.status === 1);
        if (activeDeadline != null && user.preferredDeadlineId != 0) {
          activeDeadline = user.deadline?.find(x => x.id === user.preferredDeadlineId && x.status === 1);
        }
        return activeDeadline ? activeDeadline.id : '';
      })(),
      CarrierId: (() => {
        var activeCarrier = user.carrier?.find(carrier => carrier.status === 1);
        if (activeCarrier != null && user.preferredCarrierId != 0) {
          activeCarrier = user.carrier?.find(x => x.id === user.preferredCarrierId && x.status === 1);
        }
        return activeCarrier ? activeCarrier.id : '';
      })(),
      Items: cart ? cart.items : [],
      Nature: user.domain ? user.domain[0].value : undefined,
      PaymentMethodId: user.paymentMethod ? user.paymentMethod[0].id : 0,
      Price: '',
    }
    try {
      setProductAdded(false)
      setLoadingBackground(true)
      const response = await api.post('/Invoice/Calculate', data)
      // HF-1679: bloqueia a adição de produtos com preço zerado (exceto bonificação)
      const addedItem = response.data.data?.items?.find(
        (it) => Number(it.productId) === Number(productId) && (gradeId ? Number(it.productSkuDataId) === Number(gradeId) : true),
      )
      if (addedItem && !addedItem.isBonus && (!addedItem.value || addedItem.value <= 0)) {
        toast.error('Não é possível adicionar produtos com preço zerado ao pedido. Contate a loja.', {
          position: 'top-right',
        })
        return
      }
      setCart(response.data.data)
      setProductAdded(true)
      localStorage.setItem('@bendito:cart', JSON.stringify(response.data.data))
      currentCartItems = response.data.data.items.length
      startSaveCart(response.data.data);
      toast(response.data.successMessages[0], {
        type: 'success',
        position: 'top-right',
      })
    } catch (error) {
      console.log('error', error)
      console.log('error.response', error.response)
      const receivedErrorMsg = error?.response?.data?.errorMessages[0];
      const financialNotRegular = receivedErrorMsg?.includes('pendência financeira');
      const errorMsg = financialNotRegular ? CustomFinancialToastWithLink() : receivedErrorMsg;
      toast(errorMsg, {
        type: 'error',
        position: 'top-right',
        autoClose: 10000,
      })
    } finally {
      setLoadingBackground(false)
    }
  }

  const deleteProduct = async (productId, gradeId) => {
    previousCartItems = !!cart ? cart.items.length : 0
    const updatedProducts = cart.items.filter(
      (product) => gradeId ? product.productSkuDataId !== gradeId : product.productId !== productId,
    )
    const data = {
      AddProductId: null,
      AddQuantity: null,
      ClientId: user.clientId,
      DeadlineId: (() => {
        var activeDeadline = user.deadline?.find(deadline => deadline.status === 1);
        if (activeDeadline != null && user.preferredDeadlineId != 0) {
          activeDeadline = user.deadline?.find(x => x.id === user.preferredDeadlineId && x.status === 1);
        }
        return activeDeadline ? activeDeadline.id : '';
      })(),
      CarrierId: (() => {
        var activeCarrier = user.carrier?.find(carrier => carrier.status === 1);
        if (activeCarrier != null && user.preferredCarrierId != 0) {
          activeCarrier = user.carrier?.find(x => x.id === user.preferredCarrierId && x.status === 1);
        }
        return activeCarrier ? activeCarrier.id : '';
      })(),
      Items: updatedProducts,
      Nature: user.domain ? user.domain[0].value : undefined,
      PaymentMethodId: user.paymentMethod ? user.paymentMethod[0].id : '',
      Price: '',
    }
    try {
      setLoadingBackground(true)
      const response = await api.post('/Invoice/Calculate', data)
      setCart(response.data.data)
      localStorage.setItem('@bendito:cart', JSON.stringify(response.data.data))
      currentCartItems = response.data.data.items.length
      startSaveCart(response.data.data);
    } catch (error) {
      console.log('error', error)
    } finally {
      setLoadingBackground(false)
    }
  }

  const updateMethodPayment = async (payMethod, isChatbotCatalog) => {
    const currentApi = isChatbotCatalog ? chatbotApi : api
    const currentUser = isChatbotCatalog ? chatbotCustomer : user
    const deadlineRes = await currentApi.get('/Deadline')
    
    const data = {
      AddProductId: null,
      AddQuantity: null,
      ClientId: isChatbotCatalog ? chatbotCustomer.clientId : user.clientId,
      DeadlineId: (() => {
        if (payMethod.deadline && payMethod.deadline > 0) {
          return payMethod.deadline;
        }
        var activeDeadline = deadlineRes.data.find(deadline => deadline.status === 1);
        if (activeDeadline != null && currentUser.preferredDeadlineId != 0) {
          activeDeadline = deadlineRes.data.find(x => x.id === currentUser.preferredDeadlineId && x.status === 1);
        }
        return activeDeadline ? activeDeadline.id : '';
      })(),
      Items: isChatbotCatalog ? chatbotCart.items : cart.items,
      Nature: isChatbotCatalog ? chatbotUser.domain[0].value : user.domain ? user.domain[0].value : undefined,
      PaymentMethodId: +payMethod.value,
      Price: '',
    }
    try {
      setLoadingBackground(true)
      const response = await currentApi.post('/Invoice/Calculate', data)
      if (isChatbotCatalog) {
        setChatbotCart(response.data.data)
        sessionStorage.setItem('chatbotCart', JSON.stringify(response.data.data))
      } else {
        setCart(response.data.data)
        localStorage.setItem('@bendito:cart', JSON.stringify(response.data.data))
      }
    } catch (error) {
      console.log('error', error)
    } finally {
      setLoadingBackground(false)
    }
  }

  const updateCarrier = async (carrier) => {
    const data = {
      AddProductId: null,
      AddQuantity: null,
      ClientId: user.clientId,
      DeadlineId: cart.deadlineId,
      Items: cart.items,
      Nature: user.domain ? user.domain[0].value : undefined,
      PaymentMethodId: cart.paymentMethodId,
      Price: '',
      CarrierId: +carrier.value,
    }

    try {
      setLoadingBackground(true)
      const response = await api.post('/Invoice/Calculate', data)
      setCart(response.data.data)
      localStorage.setItem('@bendito:cart', JSON.stringify(response.data.data))
    } catch (error) {
      console.log('error', error)
    } finally {
      setLoadingBackground(false)
    }
  }

  const clearCart = () => {
    setCart(null)
    localStorage.removeItem('@bendito:cart')
    setChatbotCart(null)
    sessionStorage.removeItem('chatbotCart')
    setChatbotCartObj(null)
    sessionStorage.removeItem('chatbotCartObj')
    clearChatbotCartComments()
  }

  const showCalculateErrorMessages = (error) => {
    console.log('error', error)
    console.log('error.response', error.response)
    const receivedErrorMsg = error?.response?.data?.errorMessages[0]
    const financialNotRegular = receivedErrorMsg?.includes('pendência financeira')
    const errorMsg = financialNotRegular ? CustomFinancialToastWithLink() : receivedErrorMsg
    toast(errorMsg, {
      type: 'error',
      position: 'top-right',
      autoClose: 10000,
    })
  }

  const calculateCart = async (items, firstRender) => {
    if (user?.paymentMethod[0] == null) {
      toast.error('Nenhuma forma de pagamento cadastrada pelo vendedor, por favor contate a loja!', {
        position: 'top-right',
      })
    }

    const data = {
      ClientId: user.clientId,
      DeadlineId: (() => {
        var activeDeadline = user.deadline?.find(deadline => deadline.status === 1);
        if (activeDeadline != null && user.preferredDeadlineId != 0) {
          activeDeadline = user.deadline?.find(x => x.id === user.preferredDeadlineId && x.status === 1);
        }
        return activeDeadline ? activeDeadline.id : '';
      })(),
      Items: items ? items : [],
      Nature: user.domain ? user.domain[0].value : undefined,
      PaymentMethodId: user.paymentMethod ? user.paymentMethod[0].id : 0,
      Price: '',
    }

    try {
      setProductAdded(false)
      setLoadingBackground(true)
      const response = await api.post('/Invoice/Calculate', data)
      setCart(response.data.data)
      setProductAdded(true)
      localStorage.setItem('@bendito:cart', JSON.stringify(response.data.data))
      currentCartItems = response.data.data.items.length
      startSaveCart(response.data.data);
      if (!firstRender) {
        toast(response.data.successMessages[0], {
          type: 'success',
          position: 'top-right',
        })
      }
    } catch (error) {
      showCalculateErrorMessages(error)
    } finally {
      setLoadingBackground(false)
    }
  }

  const calculateChatbotCart = async (items, firstRender) => {
    if (firstRender) return

    if (chatbotUser?.paymentMethod[0] == null) {
      toast.error('Nenhuma forma de pagamento cadastrada pelo vendedor, por favor contate a loja!', {
        position: 'top-right',
      })
    }
    
    const data = {
      ClientId: chatbotCustomer?.clientId,
      DeadlineId: (() => {
        var activeDeadline = chatbotUser?.deadline?.find(deadline => deadline.status === 1);
        if (activeDeadline != null && chatbotCustomer?.preferredDeadlineId != 0) {
          activeDeadline = chatbotUser?.deadline?.find(x => x.id === chatbotCustomer?.preferredDeadlineId && x.status === 1);
        }
        return activeDeadline ? activeDeadline.id : '';
      })(),
      Items: items ? items : [],
      Nature: chatbotUser?.domain ? chatbotUser?.domain[0].value : undefined,
      PaymentMethodId: chatbotUser?.paymentMethod ? chatbotUser?.paymentMethod[0].id : 0,
      Price: '',
    }

    try {
      setLoadingBackground(true)
      const response = await chatbotApi.post('/Invoice/Calculate', data)
      setChatbotCart(response.data.data)
      sessionStorage.setItem('chatbotCart', JSON.stringify(response.data.data))
      currentCartItems = response.data.data.items.length
      startSaveCart(response.data.data, true);
      if (!firstRender) {
        toast(response.data.successMessages[0], {
          type: 'success',
          position: 'top-right',
        })
      }
    } catch (error) {
      showCalculateErrorMessages(error)
    } finally {
      setLoadingBackground(false)
    }
  }

  const buildCharbotCartInvoiceObj = async (cartData = null, firstRender) => {
    const cartToUse = cartData || chatbotCartObj
    const isChatbotCatalog = chatbotCustomer ? true : false
    const tmpInvoiceObj = {
      productIdsAndQuantities: cartToUse,
    }
    try {
      const response = await (isChatbotCatalog ? chatbotApi : api).post('api/v2/Chatbot/ProductToInvoiceItem', tmpInvoiceObj)
      const tmpInvoiceItems = response.data.response
      isChatbotCatalog ? calculateChatbotCart(tmpInvoiceItems, firstRender) : calculateCart(tmpInvoiceItems, firstRender)
    } catch (error) {
      console.log('error:', error)
      toast.error('Catch: Falha ao montar objeto do pedido.')
    }
  }

  const getCart = async () => {
    const currentApi = chatbotCustomer ? chatbotApi : api
    const currentStorage = chatbotCustomer ? sessionStorage : localStorage
    const getAllClientCarts = await currentApi.get(`api/v2/Cart?clientId=${chatbotCustomer ? chatbotCustomer.clientId : user.clientId}`)
    const carts = getAllClientCarts?.data?.response?.data
    const lastCartIsOpen = carts[0]?.status === 1
    const lastCartId = carts[0]?.id

    if (lastCartIsOpen && lastCartId) {
      setLoadingBackground(true)
      currentStorage.setItem('@cartId', JSON.stringify(lastCartId))
      const getLastClientCart = await currentApi.get(`api/v2/Cart/${lastCartId}/Itens`)
      const lastClientCart = getLastClientCart?.data?.response?.data

      if (lastClientCart) {
        const mountObjToInvoice = lastClientCart?.reduce((acc, item) => {
          acc[item.productId] = item.quantity;
          return acc;
        }, {});

        buildCharbotCartInvoiceObj(mountObjToInvoice, true)
        if (chatbotCustomer) {
          sessionStorage.setItem('chatbotCartObj', JSON.stringify(mountObjToInvoice));
          setChatbotCartObj(mountObjToInvoice)
        }
      }
      setLoadingBackground(false)
    }
  }

  const addProductChatbotCart = async (productId, qty = 1, recalculate) => {
    const finalQuantity = parseFloat(qty)

    if (isNaN(finalQuantity) || finalQuantity <= 0) {
      await deleteProductChatbotCart(productId, true)
      return
    }

    setChatbotCartObj(prev => {
      const updatedCart = { ...prev, [productId]: finalQuantity }
      sessionStorage.setItem('chatbotCartObj', JSON.stringify(updatedCart))
      return updatedCart
    })

    if (recalculate) {
      const storedObj = JSON.parse(sessionStorage.getItem('chatbotCartObj'))
      await buildCharbotCartInvoiceObj(storedObj)
    }
  }

  const deleteProductChatbotCart = async (productId, recalculate = true) => {
    setChatbotCartObj(prev => {
      const { [productId]: removedProduct, ...updatedCartObj } = prev
      sessionStorage.setItem('chatbotCartObj', JSON.stringify(updatedCartObj))
      return updatedCartObj
    })

    if (recalculate) {
      const storedObj = JSON.parse(sessionStorage.getItem('chatbotCartObj'))
      if (Object.keys(storedObj).length > 0) {
        await buildCharbotCartInvoiceObj(storedObj)
      } else {
        await calculateChatbotCart([], false)
      }
    }
  }

  const setChatbotCartComment = (productId, comment) => {
    setChatbotCartComments(prev => {
      const updated = { ...prev, [productId]: comment }
      sessionStorage.setItem('chatbotCartComments', JSON.stringify(updated))
      return updated
    })
  }

  const removeChatbotCartComment = (productId) => {
    setChatbotCartComments(prev => {
      const { [productId]: _, ...rest } = prev
      sessionStorage.setItem('chatbotCartComments', JSON.stringify(rest))
      return rest
    })
  }

  const clearChatbotCartComments = () => {
    setChatbotCartComments({})
    sessionStorage.removeItem('chatbotCartComments')
  }

  useEffect(() => {
    function loadStoredCart () {
      setCart(JSON.parse(localStorage.getItem('@bendito:cart')))
      setChatbotCart(JSON.parse(sessionStorage.getItem('chatbotCart')) || {})
      setChatbotCartObj(JSON.parse(sessionStorage.getItem('chatbotCartObj')) || {})
      setChatbotCartComments(JSON.parse(sessionStorage.getItem('chatbotCartComments')) || {})
    }
    loadStoredCart()
    startSaveCart(cartInfo);
  }, [])

  return (
    <CartContext.Provider
      value={{
        cart,
        productAdded,
        loadingBackground,
        addProduct,
        deleteProduct,
        updateMethodPayment,
        clearCart,
        startSaveCart,
        chatbotCart,
        chatbotCartObj,
        setChatbotCartObj,
        chatbotCartComments,
        setChatbotCartComment,
        removeChatbotCartComment,
        clearChatbotCartComments,
        addProductChatbotCart,
        buildCharbotCartInvoiceObj,
        deleteProductChatbotCart,
        getCart,
        updateCarrier,
      }}
    >
      {props.children}
    </CartContext.Provider>
  )
}

export function useCart () {
  return useContext(CartContext)
}

export default CartContext